import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import focalPointApiClient from 'Services/Apis/FocalPoint/conciergeApiClient';

export const createCreditRequestThunk = createAsyncThunk(
    `CreateCreditRequestSlicer/createCreditRequestThunk`,
    async (request, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
        };

        const { data } = await focalPointApiClient.post(
            `distributionAvailableAndHistory/add-credit-request`,
            request,
            {
                headers,
            });
        return data;
    }
);

const initialState = {
    dataCreateCreditRequest: 0,
    loadingCreateCreditRequest: false,
    errorCreateCreditRequest: false,
};

const CreateCreditRequestSlicer = createSlice({
    name: 'CreateCreditRequest',
    initialState,
    reducers: {
        resetDataCreateCreditRequest: (state) => {
            state.dataCreateCreditRequest = 0;
            state.loadingCreateCreditRequest = false;
            state.errorCreateCreditRequest = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(createCreditRequestThunk.pending, (state) => {
            state.dataCreateCreditRequest = 0;
            state.loadingCreateCreditRequest = true;
            state.errorCreateCreditRequest = false;
        });
        builder.addCase(createCreditRequestThunk.fulfilled, (state, action) => {
            state.dataCreateCreditRequest = action.payload.id;
            state.loadingCreateCreditRequest = false;
            state.errorCreateCreditRequest = false;
        });
        builder.addCase(createCreditRequestThunk.rejected, (state) => {
            state.dataCreateCreditRequest = 0;
            state.loadingCreateCreditRequest = false;
            state.errorCreateCreditRequest = true;
        });
    },
});

export const { resetDataCreateCreditRequest } = CreateCreditRequestSlicer.actions;
export default CreateCreditRequestSlicer.reducer;